import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Messaggi email',
  labels: {
    view_full_message: 'Visualizza messaggio completo',
    status: 'Stato:',
    on: 'Attivo',
    off: 'Disattivo',
  },
  tiles: {
    sends_count: 'Messaggi inviati',
    delivery_rate: 'Tasso di consegna',
    delivered_suffix: 'consegnati',
    open_rate: 'Tasso di apertura',
    opened_suffix: 'aperti',
    click_rate: 'Tasso di clic',
    clicked_suffix: 'cliccati',
    spam_report_rate: 'Tasso di segnalazione spam',
    spam_reports_suffix: 'segnalazioni',
    unsubscribe_rate: 'Tasso di disiscrizione',
    unsubscribes_suffix: 'disiscrizioni',
  },
  toasts: {
    failed_to_update_status: 'Aggiornamento stato non riuscito',
    failed_to_load_data: 'Caricamento dati non riuscito',
  },

  preview_modal: {
    title: 'Anteprima template',
    labels: {
      subject: 'Oggetto:',
      close: 'Chiudi',
    },
    toasts: {
      failed_to_load_data: "Caricamento dell'anteprima non riuscito",
    },
    template_data: {
      recipient_name: '&lt;Nome&gt;',
    },
  },
};
